var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 108,
    viewBox: "0 0 109 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1754_7713)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 30,
    width: 40,
    height: 40,
    rx: 11.875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.25 41.75H35.75C35.3522 41.75 34.9706 41.908 34.6893 42.1893C34.408 42.4706 34.25 42.8522 34.25 43.25V57.5C34.2501 57.6278 34.2828 57.7535 34.3451 57.8651C34.4074 57.9768 34.4972 58.0706 34.606 58.1378C34.7147 58.2049 34.8389 58.2432 34.9666 58.2489C35.0943 58.2546 35.2213 58.2275 35.3356 58.1703L38 56.8381L40.6644 58.1703C40.7686 58.2225 40.8835 58.2496 41 58.2496C41.1165 58.2496 41.2314 58.2225 41.3356 58.1703L44 56.8381L46.6644 58.1703C46.7686 58.2225 46.8835 58.2496 47 58.2496C47.1165 58.2496 47.2314 58.2225 47.3356 58.1703L50 56.8381L52.6644 58.1703C52.7787 58.2275 52.9057 58.2546 53.0334 58.2489C53.1611 58.2432 53.2853 58.2049 53.394 58.1378C53.5028 58.0706 53.5926 57.9768 53.6549 57.8651C53.7172 57.7535 53.7499 57.6278 53.75 57.5V43.25C53.75 42.8522 53.592 42.4706 53.3107 42.1893C53.0294 41.908 52.6478 41.75 52.25 41.75ZM48.5 51.5H39.5C39.3011 51.5 39.1103 51.421 38.9697 51.2803C38.829 51.1397 38.75 50.9489 38.75 50.75C38.75 50.5511 38.829 50.3603 38.9697 50.2197C39.1103 50.079 39.3011 50 39.5 50H48.5C48.6989 50 48.8897 50.079 49.0303 50.2197C49.171 50.3603 49.25 50.5511 49.25 50.75C49.25 50.9489 49.171 51.1397 49.0303 51.2803C48.8897 51.421 48.6989 51.5 48.5 51.5ZM48.5 48.5H39.5C39.3011 48.5 39.1103 48.421 38.9697 48.2803C38.829 48.1397 38.75 47.9489 38.75 47.75C38.75 47.5511 38.829 47.3603 38.9697 47.2197C39.1103 47.079 39.3011 47 39.5 47H48.5C48.6989 47 48.8897 47.079 49.0303 47.2197C49.171 47.3603 49.25 47.5511 49.25 47.75C49.25 47.9489 49.171 48.1397 49.0303 48.2803C48.8897 48.421 48.6989 48.5 48.5 48.5Z",
    fill: "#B7BFCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1754_7713",
    x: -20.5312,
    y: 0.3125,
    width: 129.062,
    height: 129.062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.8438
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.2656
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7 0 0 0 0 0.7 0 0 0 0 0.7 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1754_7713"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1754_7713",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTi);
export default __webpack_public_path__ + "static/media/ti.b48f621a240ec8e7c55536e2a7a05c88.svg";
export { ForwardRef as ReactComponent };